import { Data, UID } from '@strapi/types'

// Using approach from https://strapi.io/blog/improve-your-frontend-experience-with-strapi-types-and-type-script

export type ContentType = UID.ContentType

export const ContentTypeRoutes = {
  'api::adapter.adapter': 'adapters',
  'api::frontend-i18n.frontend-i18n': 'frontend-i18n',
  'api::adapter-category.adapter-category': 'adapter-categories',
  'api::knowledge-hub.knowledge-hub': 'knowledge-hub',
  'api::quick-start-guide.quick-start-guide': 'quick-start-guide',
  'api::marketplace.marketplace': 'marketplace',
  'api::report-help.report-help': 'report-helps',
  'api::glossary-term.glossary-term': 'glossary-terms',
  'api::kpi.kpi': 'kpis',
} as Record<ContentType, string>

export const ContentQueryMap = {
  'api::adapter.adapter': {
    list: '?populate=*',
    single: '?populate=*',
  },
  'api::report-help.report-help': {
    list: '?populate=*',
    single: '?populate=*',
  },
  'api::frontend-i18n.frontend-i18n': {
    single: '?pLevel=5',
  },
  'api::adapter-category.adapter-category': {
    list: '?populate=*',
    single: '?populate=*',
  },
  'api::knowledge-hub.knowledge-hub': {
    single: '?pLevel=5',
  },
  'api::quick-start-guide.quick-start-guide': {
    single: '?pLevel=5',
  },
  'api::marketplace.marketplace': {
    single: '?pLevel=5',
  },
} as Record<ContentType, { list?: string, single: string }>

export interface APIResponseCollectionMetadata {
  pagination: {
    page: number
    pageSize: number
    pageCount: number
    total: number
  }
}

export interface APIResponse<TContentTypeUID extends UID.ContentType> {
  data: Data.ContentType<TContentTypeUID>
}

export interface APIResponseCollection<
  TContentTypeUID extends UID.ContentType,
> {
  data: Data.ContentType<TContentTypeUID>[]
  meta: APIResponseCollectionMetadata
}

export type Content<TContentTypeUID extends UID.ContentType> = Data.ContentType<TContentTypeUID>
